import { Container } from "@mantine/core"
import { ErrorBox, Loader } from "@tfg/ui"
import { t } from "i18next"

import { CustomTable } from "~/components/table/CustomTable"
import { CertificateByOrganizationDto } from "~/gen/api"
import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

export const CertificatesList = () => {
  const {
    data,
    setSelectedCertificateInfo,
    isLoading,
    isError,
    error,
    table,
    setIsColumnManagerOpen,
  } = useCertificatesTableContext()

  const { total } = data

  if (isLoading) return <Loader fullPage />
  if (isError || !table) {
    return (
      <Container mt="5%" w="100%" h="100%">
        <ErrorBox title={t("dataLoad.error.title")} error={error} />
      </Container>
    )
  }

  return (
    <CustomTable<CertificateByOrganizationDto>
      table={table}
      onRowClick={(row: CertificateByOrganizationDto) => {
        setSelectedCertificateInfo(row)
      }}
      manualPaginationCount={total}
      setOpenColumnManager={setIsColumnManagerOpen}
    />
  )
}
